'use strict';

const mixin = {
	mounted() {
		console.log('app created');
		// if (this.year) this.$store.commit('currentYear', this.year);

		this.loadCalledSeats(this.year);
	},
	methods: {
		loadCalledSeats(year) {
			console.log(`${(this._vnode || {}).tag}: election > loadCalledSeats`);

			this.$store.dispatch('loadCalledSeats', year)
				.then(() => {
					console.log(`${(this._vnode || {}).tag}: loadCalledSeats dispatch promise response`);
				});
		}
	}
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/loadCalledSeats.js